import { apiSlice } from "../../app/api/apiSlice";

const QUERY_URL = "/import";

export const importApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    parseImportFile: builder.mutation({
      query: (formData) => ({
        url: `${QUERY_URL}/parse`,
        method: "POST",
        body: formData,
      }),
    }),
    validateImportData: builder.mutation({
      query: (data) => ({
        url: `${QUERY_URL}/validate`,
        method: "POST",
        body: data,
      }),
    }),
    executeImport: builder.mutation({
      query: (data) => ({
        url: `${QUERY_URL}/execute`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Member", "Site", "Contract", "Booking", "Event"],
    }),
    detectDataTypes: builder.mutation({
      query: (data) => ({
        url: `${QUERY_URL}/detect`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useParseImportFileMutation,
  useValidateImportDataMutation,
  useExecuteImportMutation,
  useDetectDataTypesMutation,
} = importApiSlice;
